<template>
  <div>
    <div class="heard">
      <div class="main">
          <h1 class="logo" :style="{background: 'url('+url+'/assets/logo-top.png) no-repeat'}"></h1>
          <div class="tab">
            <ul>
              <li v-for="(item) in tab" :class="active == item.index?'active':''" v-on:mouseover="mouseover(item.path)" v-on:mouseout="mouseout(item.path)" @click="moveTo(item.index,item.path)" :key="item.id">{{item.name}}</li>
            </ul>
            <div class="list" v-show="hide">
              <p v-for="(item, index) in list" :class="listactive == index?'listactive':''" :key="index" v-on:mouseout="mouseoutNav(item.path)" v-on:mouseover="mouseoverNav()" @click="nav(index,item.path)">{{item.name}}</p>
            </div>
            <div class="phone pulse"><img :src="url + '/assets/phone.png'">0516-83309697</div>
          </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
export default {
  name: 'yeMast',
  data() {
    return {
      url: defaultSettings.url,
      active: 0,
      listactive: 0,
      hide: false,
      list: [
        {
          id: '1',
          name:'智慧安防',
          path: 'security'
        },
        {
          id: '2',
          name:'智慧警务',
          path: 'policeWork'
        },
        {
          id: '3',
          name:'智慧园区',
          path: 'park'
        },
      ],
      tab: [
        {
          id: '1',
          name:'首页',
          index: 0,
          path: 'yeMast'
        },
        {
          id: '2',
          index: 1,
          name:'产品展厅',
          path: 'product'
        },
        {
          id: '3',
           index: 2,
          name:'解决方案',
          path: 'security'
        },
        {
          id: '4',
           index: 3,
          name:'合作伙伴',
          path: 'cooperation'
        },
        {
          id: '5',
           index: 4,
          name:'关于野马',
          path: 'AboutMustang'
        },
        {
          id: '6',
           index: 5,
          name:'联系我们',
          path: 'contactUs'
        }
      ],
      hideRouter: true
    }
  },
  created() {
    if (this.$route.path === '/yeMast') {
      this.listactive = 0
      this.hide = false
      this.active = 0
      this.tab[0].index = 0
      this.$router.replace({name: 'yeMast'})
    } else if (this.$route.path === '/product') {
      this.listactive = 0
      this.hide = false
      this.active = 1
      this.tab[1].index = 1
      this.$router.replace({name: 'product'})
    } else if (this.$route.path === '/security' || this.$route.path === '/park' || this.$route.path === '/policeWork') {
      // this.hide = true
      this.active = 2
      this.tab[2].index = 2
      this.$router.replace({name: 'security'})
    } else if (this.$route.path === '/cooperation') {
      this.listactive = 0
      this.hide = false
      this.active = 3
      this.tab[3].index = 3
      this.$router.replace({name: 'cooperation'})
    } else if (this.$route.path === '/AboutMustang') {
      this.listactive = 0
       this.hide = false
      this.active = 4
      this.tab[4].index = 4
      this.$router.replace({name: 'AboutMustang'})
    } else if (this.$route.path === '/contactUs') {
      this.listactive = 0
      this.hide = false
      this.active = 5
      this.tab[5].index = 5
      this.$router.replace({name: 'contactUs'})
    }
  },
  methods: {
    mouseout(path) {
      if (path === 'security') {
         this.hide = false
      }
    },
    mouseover(path) {
      if (path === 'security') {
         this.active = 2
        this.tab[2].index = 2
        // this.$router.replace({name: 'security'})
         this.hide = true
      }
    },
    mouseoutNav() {
      this.hide = false
    },
     mouseoverNav() {
       this.hide = true
    },
    moveTo(index, path) {
      this.active = index
      this.$router.replace({name: path})
      if (path !== 'security') {
        this.hide = false
      } else {
        this.hide = true
        // setTimeout(() => {
        //   this.hide = false
        // }, 3000)
      }
    },
    nav (index, path) {
      // setTimeout(() => {
      //   this.hide = false
      // }, 3000)
      this.listactive = index
      this.$router.replace({name: path})
    },
  }
}
</script>
<style lang="less" scoped>
  .heard {
    position: fixed;
    width:100%;
    height: 90px;
    line-height: 90px;
    background: #ffffffe0;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    z-index: 99;
    .main{
      width:1600px;
      margin:0 auto;
      .logo {
        width: 426px;
        height: 60px;
        display: inline-block;
        line-height:60px;
        vertical-align: middle;
        background-size: contain!important;
      }
  
      .tab {
        float: right;
        height:90px;
        display: flex;
        position: relative;
        ul {
          height: 100%;
  
          li {
            float: left;
            list-style: none;
            height: 90px;
            line-height: 90px;
            margin-right: 52px;
            font-size: 18px;
            color:#333333;
            font-family: Microsoft YaHei;
            cursor: pointer;
          }
  
          .active {
            font-weight: bold;
            color: #333333;
          }
        }
        .list{
          position: absolute;
          width:112px;
          background: #fff;
          border:1px solid #ddd;
          left:195px;
          top:88px;
          text-align: center;
          p{
            height:40px;
            line-height:40px;
            font-size:16px;
            color:#333;
          }
          p:hover{
            background: #e0e0e0;
          }
          .listactive{
            background: #167efb!important;
            color:#fff;
          }
        }
      }

      .phone{
        color:#C64509;
        font-size:20px;
        cursor: pointer;
        img{
          width:30px;
          height:30px;
          margin-right:10px;
          vertical-align: -7px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/view/top.vue